import * as React from "react";

type TherapistRewardData = [number, (unreadTherapistRewardCount: number) => void];

const TherapistRewardContext = React.createContext<TherapistRewardData>([0, () => ({})]);

export default TherapistRewardContext;